jQuery(function($) {
	let useClass = true;

	$('.modal__header__close').on('click', function() {
		let dialog = $(this).closest('.modal');
		$(dialog).removeClass('modal-open');
		$('body').removeClass('modal-open');
		$('document').trigger('modal_closed', dialog);

		if(useClass) {
			$(dialog).removeClass('modal-open');
			$('body').removeClass('modal-open');
			$('document').trigger('modal_closed', dialog);
		} else {
			$(dialog)[0].close();
			$('body').removeClass('modal-open');
			$('document').trigger('modal_closed', dialog);
		}
	});

	$('[data-btn-action="openModal"]').on('click', function(e) {
		e.preventDefault();
		let dialog = $(this).attr('data-modal-target');

		if($(dialog).find('div[data-val="title"]').length) {
			$('#input_4_9').val( $(this).data('id'));
		}

		if($(dialog).find('div[data-val="title"]').length) {
			$(dialog).find('div[data-val="title"]').html('<div data-val="title">'+ $(this).data('title') +'</div>');
		}

		if(useClass) {
			$(dialog).addClass('modal-open');
			$('body').addClass('modal-open');
			$('document').trigger('modal_opened', dialog);
		} else {
			$(dialog)[0].showModal();
			$('body').addClass('modal-open');
			$('document').trigger('modal_opened', dialog);
		}
	});

	$('document').on('modal_opened', function(e, dialog) {
	});

	$('document').on('modal_closed', function(e, dialog) {
	});
});
